/*
 * @prop --component-headline-color-level-1: Color of level 1 headline
 * @prop --component-headline-color-level-2: Color of level 2 headline
 * @prop --component-headline-color-level-3: Color of level 3 headline
 * @prop --component-headline-color-level-4: Color of level 4 headline
 * @prop --component-headline-color-level-5: Color of level 5 headline
 * @prop --component-headline-font-family: The font family of the headline
*/

:host {
  display: flex;

  ui-icon {
    font-size: 36px;
    line-height: 44px;
    margin-right: 16px;
    margin-top: 5px;
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
  }

  .ui-headline {
    max-width: 100%;
    font-family: var(--component-headline-font-family, var(--skin-font-family-primary, $font-family-sans-serif));
    font-weight: $font-weight-bold;
    word-break: break-word;

    ::slotted(p:first-of-type) {
      margin-top: 0;
    }

    ::slotted(p) {
      margin-top: 8px;
      margin-bottom: 0;

      @include breakpoint($medium) {
        margin-top: 12px;
      }
    }

    @include breakpoint($medium) {
      word-break: unset;
    }

    &--1 {
      font-family:
        var(
          --component-headline-font-family-level-1,
          var(--skin-font-family-primary, $font-family-sans-serif)
        );
      font-style: var(--component-headline-font-style-level-1, $body-font-style);
      color: var(--component-headline-color-level-1, var(--current-color-primary, $ui-blue));
      display: inline-block;
      font-size: 32px;
      line-height: 44px;
      margin: 0;

      @include breakpoint($medium) {
        font-size: 40px;
        line-height: 48px;
      }

      ::slotted(mark) {
        @extend %mark;
      }
    }

    &--2 {
      font-family:
        var(
          --component-headline-font-family-level-2,
          var(--skin-font-family-primary, $font-family-sans-serif)
        );
      font-style: var(--component-headline-font-style-level-2, $body-font-style);
      color: var(--component-headline-color-level-2, var(--current-color-primary, $ui-blue));
      display: inline-block;
      font-size: 28px;
      line-height: 36px;
      margin: 0;

      @include breakpoint($medium) {
        font-size: 32px;
        line-height: 44px;
      }

      ::slotted(mark) {
        @extend %mark;
      }
    }

    &--3 {
      font-family:
        var(
          --component-headline-font-family-level-3,
          var(--skin-font-family-primary, $font-family-sans-serif)
        );
      font-style: var(--component-headline-font-style-level-3, $body-font-style);
      color: var(--component-headline-color-level-3, var(--current-color-text, $ui-dark));
      display: inline-block;
      font-size: 20px;
      line-height: 28px;
      margin: 0;

      ::slotted(mark) {
        @extend %mark;
      }
    }

    &--4 {
      font-family:
        var(
          --component-headline-font-family-level-4,
          var(--skin-font-family-primary, $font-family-sans-serif)
        );
      font-style: var(--component-headline-font-style-level-4, $body-font-style);
      color: var(--component-headline-color-level-4, var(--current-color-text, $ui-dark));
      display: inline-block;
      font-size: 16px;
      line-height: 24px;
      margin: 0;
    }

    &--5 {
      font-family:
        var(
          --component-headline-font-family-level-5,
          var(--skin-font-family-primary, $font-family-sans-serif)
        );
      font-style: var(--component-headline-font-style-level-5, $body-font-style);
      color: var(--component-headline-color-level-5, var(--current-color-primary, $ui-blue));
      display: inline-block;
      font-size: 16px;
      line-height: 24px;
      margin: 0;
    }

    &--centered {
      margin: auto;
      text-align: center;
      display: inline-block;
    }
  }

  ::slotted(sup) {
    font-size: 75%;
    line-height: 0;
    position: relative;
    top: -.5em;
    vertical-align: baseline;
  }
}

:host([conversion='superteaser']) {
  .ui-headline {
    &--1 {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      text-shadow: inherit;
    }
  }
}

:host(.inherit-font-style) {
  .ui-headline {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
}
